import { convertMusicProductPhysicalQueryToForm as queryToForm } from "./musicProductPhysicalQueryToForm";
import { convertTracksToAlbumsForm as tracksToAlbums } from "./tracksToAlbums";
import { musicProductPhysicalFormToQuery as formToQuery } from "./musicProductPhysicalFormToQuery";
import { settlementInfoFormToQuery } from "./settlementInfoFormToQuery";

export default {
  tracksToAlbums,
  queryToForm,
  formToQuery,
  settlementInfoFormToQuery,
};
